export const ITEM_TYPES = {
  0: 'APIARY',
  1: 'TREE',
  2: 'DECORATION',
};
export default {
  ITEM_TYPES,
};
